import React from "react"
import {
  BackLabelledIcon,
  IconButton,
} from "ksc-portal-common-components/atoms"

export default ({ onClick }: { onClick: Function }) => (
  <div className="pp-back-button-container">
    <IconButton
      onClick={onClick}
      className="pp-back-button"
      aria-label="back button"
    >
      <BackLabelledIcon />
    </IconButton>
  </div>
)
